import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { totalPrice } from "../../utils";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";



const Header = (props) => {
    const [menuActive, setMenuState] = useState(false);
    const [cartActive, setcartState] = useState(false);

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { carts } = props;


    return (
        <header id="header">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-lg-2 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-lg-4 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/"><img src={props.Logo}
                                        alt="logo" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-childre">
                                            <Link onClick={ClickHandler} to="/">Home</Link>
                                            {/* <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/home">Home style 1</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-2">Home style 2</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-3">Home style 3</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-4">Home style 4</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-5">Home style 5</Link></li>
                                                <li><Link onClick={ClickHandler} to="/home-6">Home style 6</Link></li>
                                            </ul> */}
                                        </li>
                                        <li className="menu-item-has-childre">
                                            <Link onClick={ClickHandler} to="/service">Products</Link>
                                            <ul className="sub-menu">

                                                {/* Earthing Solutions */}
                                                <li className="menu-item-has-children">
                                                    <Link onClick={ClickHandler} to="/earthsolutionpage">Earthing Solutions</Link>
                                                    <ul className="sub-menu">

                                                        {/* Earthing Electrodes */}
                                                        <li className="menu-item-has-children">
                                                            <Link onClick={ClickHandler} to="#">Earthing Electrodes</Link>
                                                            <ul className="sub-menu">
                                                                <li><Link onClick={ClickHandler} to="/service-details/gi-earthing-electrodes">GI (Galvanized-Iron)Earthing-Electrodes</Link></li>
                                                                <li><Link onClick={ClickHandler} to="/service-details/copper-bonded-earthing-electrodes">Copper-Bonded-Earthing-Electrodes</Link></li>
                                                                <li><Link onClick={ClickHandler} to="/service-details/pure-copper-earthing-electrodes">Pure Copper-Earthing-Electrodes</Link></li>
                                                            </ul>
                                                        </li>

                                                        {/* Lightning Arrestors */}
                                                        <li className="menu-item-has-children">
                                                            <Link onClick={ClickHandler} to="#">Lightning Arrestors</Link>
                                                            <ul className="sub-menu">
                                                                <li><Link onClick={ClickHandler} to="/service-details/ese-lightning-arrestors">ESE Lightning Arrestor</Link></li>
                                                                <li className="menu-item-has-children">
                                                                    <Link onClick={ClickHandler} to="#">Conventional <br></br>Lightning Arrestors</Link>
                                                                    <ul className="sub-menu">
                                                                        <li><Link onClick={ClickHandler} to="/service-details/pure-copper-solid-lighting-arrestors">Pure Copper Solid Lightning Arrestor</Link></li>
                                                                        <li><Link onClick={ClickHandler} to="/service-details/copper-bonded-lightning-arrestor">Copper Bonded Lightning Arrestor 4/5 Spikes With Base Plate</Link></li>
                                                                        <li><Link onClick={ClickHandler} to="/service-details/copper-hollow-lightning-arrestors-with-base-plates">Copper Hollow Lightning Arrestors With Base Plates</Link></li>
                                                                    </ul>
                                                                </li>
                                                            </ul>
                                                        </li>

                                                        {/* Earth Pit Covers */}
                                                        <li className="menu-item-has-children">
                                                            <Link onClick={ClickHandler} to="#">Earth Pit Covers</Link>
                                                            <ul className="sub-menu">
                                                                <li><Link onClick={ClickHandler} to="/service-details/square-earth-pit-covers">Square Earth Pit Covers</Link></li>
                                                                <li><Link onClick={ClickHandler} to="/service-details/round-earth-pit-covers">Round Earth Pit Covers</Link></li>
                                                            </ul>
                                                        </li>

                                                        {/* Back Fill Compound */}
                                                        <li className="menu-item-has-children">
                                                            <Link onClick={ClickHandler} to="#">Back Fill Compound</Link>
                                                            <ul className="sub-menu">
                                                                <li><Link onClick={ClickHandler} to="/service-details/silver-back-fill-compounds">Silver Back Fill compounds</Link></li>

                                                            </ul>
                                                        </li>

                                                        {/* Earthing Strips */}
                                                        <li className="menu-item-has-children">
                                                            <Link onClick={ClickHandler} to="#">Earthing Strips</Link>
                                                            <ul className="sub-menu">
                                                                <li><Link onClick={ClickHandler} to="/service-details/gi-strips">GI Strips</Link></li>
                                                                <li><Link onClick={ClickHandler} to="/service-details/copper-strips">Copper Strips</Link></li>
                                                            </ul>
                                                        </li>

                                                        {/* Conventional Earthing */}
                                                        <li className="menu-item-has-children">
                                                            <Link onClick={ClickHandler} to="#">Conventional Earthing</Link>
                                                            <ul className="sub-menu">
                                                                <li><Link onClick={ClickHandler} to="/service-details/copper-earthing-plates">Copper Earthing Plates</Link></li>
                                                                <li><Link onClick={ClickHandler} to="/service-details/gi-plates">GI Plates</Link></li>
                                                                <li><Link onClick={ClickHandler} to="/service-details/copper-bonded-plates">Copper Bonded Plates</Link></li>
                                                            </ul>
                                                        </li>

                                                        {/* Exothermic Welding */}
                                                        <li className="menu-item-has-children">
                                                            <Link onClick={ClickHandler} to="/service-details/exothermic-welding">Exothermic Welding</Link>
                                                        </li>

                                                    </ul>
                                                </li>

                                                {/* Cable Trays */}
                                                <li>
                                                    <Link onClick={ClickHandler} to="/cabletrayspage">Cable Trays</Link>
                                                    <ul className="sub-menu">
                                                        <li><Link onClick={ClickHandler} to="/service-details/perforated-cable-tray">Perforated Cable Tray</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/service-details/ladder-type-cable-tray">Ladder Type Cable Tray</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/service-details/cable-tray-cover">Cable Tray Cover</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/service-details/cable-tray-accessories">Cable Tray Accessories</Link></li>
                                                        <li><Link onClick={ClickHandler} to="/service-details/raceway-ducts-trucking">Raceway/ Ducts/ Trucking</Link></li>
                                                    </ul>
                                                </li>

                                            </ul>

                                            {/* <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/service">Service Style 1</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-s2">Service Style 2</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-s3">Service Style 3</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-single/Power-&-Energy-Sectors">Service Single</Link></li>
                                            </ul> */}
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/about">About</Link></li>

                                        <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                            {/* <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right">
                                    <div className="mini-cart">
                                        <button className="cart-toggle-btn" onClick={() => setcartState(!cartActive)}>
                                            {" "}
                                            <i className="fi flaticon-shopping-cart"></i>
                                            <span className="cart-count">{carts.length}</span>
                                        </button>
                                        <div className={`mini-cart-content ${cartActive ? "mini-cart-content-toggle" : ""}`}>
                                            <button className="mini-cart-close" onClick={() => setcartState(!cartActive)}><i className="ti-close"></i></button>
                                            <div className="mini-cart-items">
                                                {carts &&
                                                    carts.length > 0 &&
                                                    carts.map((catItem, crt) => (
                                                        <div className="mini-cart-item clearfix" key={crt}>
                                                            <div className="mini-cart-item-image">
                                                                <span>
                                                                    <img src={catItem.proImg} alt="icon" />
                                                                </span>
                                                            </div>
                                                            <div className="mini-cart-item-des">
                                                                <p>{catItem.title} </p>
                                                                <span className="mini-cart-item-price">
                                                                    ${catItem.price} x {" "} {catItem.qty}
                                                                </span>
                                                                <span className="mini-cart-item-quantity">
                                                                    <button
                                                                        onClick={() =>
                                                                            props.removeFromCart(catItem.id)
                                                                        }
                                                                        className="btn btn-sm btn-danger"
                                                                    >
                                                                        <i className="ti-close"></i>
                                                                    </button>{" "}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                            <div className="mini-cart-action clearfix">
                                                <span className="mini-checkout-price">Subtotal: <span> ${totalPrice(carts)}</span></span>
                                                <div className="mini-btn">
                                                    <Link to="/checkout" className="view-cart-btn s1">Checkout</Link>
                                                    <Link to="/cart" className="view-cart-btn">View Cart</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="header-search-form-wrapper">
                                        <div className="cart-search-contact">
                                            <button onClick={() => setMenuState(!menuActive)} className="search-toggle-btn"><i
                                                className={`fi ti-search ${menuActive ? "ti-close" : "fi "}`}></i></button>
                                            <div className={`header-search-form ${menuActive ? "header-search-content-toggle" : ""}`}>
                                                <form onSubmit={SubmitHandler}>
                                                    <div>
                                                        <input type="text" className="form-control"
                                                            placeholder="Search here..." />
                                                        <button type="submit"><i
                                                            className="fi flaticon-loupe"></i></button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="close-form">
                                        <Link onClick={ClickHandler} className="theme-btn" to="/contact">Get In Touch</Link>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}
const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};


export default connect(mapStateToProps, { removeFromCart })(Header);